(() => {
  const root = document.querySelector('[data-sp-faq]');

  if (!root) return;

  const chips = Array.from(root.querySelectorAll('[data-sp-faq-chip]'));
  const sections = Array.from(root.querySelectorAll('[data-sp-faq-section]'));

  const headerOffset = () => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--sp-header-height');
    const parsed = Number.parseFloat(raw);

    return Number.isFinite(parsed) ? parsed : 76;
  };

  const setActiveChip = (id) => {
    chips.forEach((chip) => {
      const on = chip.dataset.spFaqChip === id;

      chip.classList.toggle('is-active', on);

      if (on) {
        chip.setAttribute('aria-current', 'true');
        return;
      }

      chip.removeAttribute('aria-current');
    });
  };

  const syncFromScroll = () => {
    const line = headerOffset() + 72;
    let current = chips[0]?.dataset.spFaqChip || '';

    sections.forEach((section) => {
      if (section.getBoundingClientRect().top <= line) current = section.id;
    });

    if (current) setActiveChip(current);
  };

  const syncHash = () => {
    const slug = window.location.hash.replace(/^#/, '');

    if (!slug) {
      syncFromScroll();
      return;
    }

    if (root.querySelector(`[data-sp-faq-chip="${CSS.escape(slug)}"]`)) {
      setActiveChip(slug);
      chips
        .find((chip) => chip.dataset.spFaqChip === slug)
        ?.scrollIntoView({ inline: 'center', block: 'nearest' });
      return;
    }

    const target = root.querySelector(`#${CSS.escape(slug)}`);
    const section = target?.closest('[data-sp-faq-section]');

    if (section?.id) setActiveChip(section.id);
  };

  let ticking = false;

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        syncFromScroll();
        ticking = false;
      });
    },
    { passive: true }
  );

  syncHash();
  window.addEventListener('hashchange', syncHash);
  window.addEventListener('load', syncHash);
})();
